import {importAll} from './webpack/_helpers';
import './src/assets/scripts/layout';

// импорт всех стилей компонентов
import '@views/scss/_startup.scss';

// импорт скриптов всех компонентов
// важно! используется jquery
importAll(require.context('./src/views/js/', true, /\.js$/));
importAll(require.context('./src/views/components/', true, /\.js$/));

// импорт svg для составления спрайта
importAll(require.context('./src/assets/svg/', true, /\.svg$/));
